import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router";

import "assets/scss/material-kit-pro-react.scss?v=1.3.0";

// import LandingPage from "views/LandingPage/LandingPage.jsx";

// TEN Project
import PortalPage from "views/PortalPage/PortalPage.jsx";
import TenPage from "views/TenPage/TenPage.jsx";
// import Ten2Page from "views/Ten2Page/Ten2Page.jsx";
// import CataloguePage from "views/CataloguePage/CataloguePage.jsx";
import PDCataloguePage from "views/PDCataloguePage/PDCataloguePage.jsx";
import CourseDetailsPage from "views/CourseDetailsPage/CourseDetailsPage.jsx";
// import AboutPage from "views/AboutPage/AboutPage.jsx";
// import ContactUsPage from "views/ContactUsPage/ContactUsPage.jsx";
// import CapabilityExplorerPage from "views/CapabilityExplorerPage/CapabilityExplorerPage.jsx";
// import CapabilityExplorerToolPage from "views/CapabilityExplorerToolPage/CapabilityExplorerToolPage.jsx";
import CapExplorerResultsPage from "views/CapExplorerResultsPage/CapExplorerResultsPage.jsx";

// Google Analytics
import ReactGA from "react-ga";

// Scroll Managemnt
import { ScrollManager, WindowScroller } from "react-scroll-manager";

// Import AWS Amplify
import Amplify, { API } from 'aws-amplify';

// Get Environment Variables
const GA_KEY = process.env.REACT_APP_GA_KEY;
const API_TEN_PUBLIC = process.env.REACT_APP_API_TEN_PUBLIC;

Amplify.configure({
  // OPTIONAL - if your API requires authentication
  // Auth: {
  //   // REQUIRED - Amazon Cognito Identity Pool ID
  //   identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',
  //   // REQUIRED - Amazon Cognito Region
  //   region: 'XX-XXXX-X',
  //   // OPTIONAL - Amazon Cognito User Pool ID
  //   userPoolId: 'XX-XXXX-X_abcd1234',
  //   // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
  //   userPoolWebClientId: 'a1b2c3d4e5f6g7h8i9j0k1l2m3',
  // },
  API: {
    endpoints: [
      {
        name: "capabilityexplorer",
        endpoint: API_TEN_PUBLIC
      }
    ]
  }
});

var hist = createBrowserHistory();
ReactGA.initialize({ GA_KEY });
hist.listen(location => ReactGA.pageview(location.pathname));

ReactDOM.render(
  <ScrollManager history={hist}>
    <Router onUpdate={() => window.scrollTo(0, 0)} history={hist}>
      <WindowScroller>
        <Switch>
          {/* <Route path="/contactus" component={ContactUsPage} /> */}
          {/* <Route path="/about" component={AboutPage} /> */}
          {/* <Route path="/catalogue" component={PDCataloguePage} /> */}
          <Route path="/catalogue" component={PDCataloguePage} />
          <Route path="/module/:courseId" component={CourseDetailsPage} />
          <Route path="/ten" component={TenPage} />
          {/* <Route
            path="/capabilityexplorer/start"
            component={CapabilityExplorerToolPage}
          /> */}
          <Route
            path="/capabilityexplorer/results/:submissionId"
            component={CapExplorerResultsPage}
          />
          {/* <Route
            path="/capabilityexplorer/"
            component={CapabilityExplorerPage}
          /> */}
          <Route path="/" component={PortalPage} />
        </Switch>
      </WindowScroller>
    </Router>
  </ScrollManager>,
  document.getElementById("root")
);
